// There is no Records Page, but we use the title for the breadcrumbs
const RECORDS_PAGE_TITLE = "Records";

export const RECORDS_PAGE_BREADCRUMB = {
  title: RECORDS_PAGE_TITLE,
};
